<template>
  <div class="container main has-submenu" :class="{ fullwidth : !loggedIn }">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
        <div class="panel panel-info" style="margin-top:0;">
            <div class="panel-heading">
              <h3 class="panel-title" style="font-size:20px;">Transactions
                <!-- <router-link :to="{ path: '/account/link' }" style="float:right; margin-bottom:10px;">
                  <button type="button" title="Add new acount" class="btn btn-info btn-circle btn-lg"><i class="fa fa-plus"></i></button>
                </router-link> -->
              </h3>
            </div>
              <div class="panel-body">
                  <div class="row placeholders" style="margin-bottom:0">
                    <div class="col-sm-3 placeholder">
                      <router-link to="/account/transfer" class="btn btn-sq-lg btn-primary">
                        <img src="../../../static/img/sendmoney.png" alt="Send money" class="img-responsive">
                      </router-link>
                      <h4><a href="" target="">Send LajanCash</a></h4>
                    </div>
                    <!-- <request-money></request-money> -->
                    <div class="col-sm-3 placeholder">
                      <router-link to="/account/request" class="btn btn-sq-lg btn-primary">
                        <img src="../../../static/img/requestmoney.png" alt="Request money" class="img-responsive">
                      </router-link>
                      <h4><a href="" target="">Request LajanCash</a></h4>
                    </div>
                  </div>
                </div>
                <div>
                <hr></div>
                <h3 class="font-size-normal history">Purchase History</h3>
                <!-- Transaction history -->
                <history></history>
            </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- </div> -->
</template>
<script>
  import Vue from 'vue'
  // import RequestMoney from '../Sendmoney/RequestMoney.vue'
  import {HTTP} from '../../services/account-services.js'
  import Vue2Filters from 'vue2-filters'
  import History from './History.vue'
  Vue.use(Vue2Filters)
  // import {HTTP} from '../../services/request-services.js'
  // import axios from 'axios'
  export default {
    name: 'Transactions',
    components: {
      // RequestMoney
      History
    },
    data() {
      return {
        histories: {},
        formSubmitted: false,
        lastStep: false,
        loading: true,
        noHistory: false,
        hasNoCardHistory: false,
        hasNoBankHistory: false,
        hasNoWalletHistory: false
      }
    },
    methods: {
      getHistory() {
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        console.log('History')
        HTTP.get('/accounts/' + userId + '/history?limit=10&access_token=' + token)
          .then(response => {
            if (response.data.data.lenght === 0) {
              this.noHistory = true
              this.loading = false
            } else {
              this.histories = response.data.data
              this.loading = false
              console.log(response.data)
            }
          }).catch(function(e) {
            console.log(e)
          })
      }
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    mounted() {
      // this.getHistory()
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
.transaction {
  margin-top: 5px;
}
.history {
  margin-left: 20px;
}
.outline {
  background-color: transparent;
  color: inherit;
  transition: all .25s;
  border-radius: 4px;
  width: 120px;
}
.btn-info.outline {
  color: #428bca;
}
.btn-info.outline:hover{
  color: #fff;
}
.clearfix {
  overflow: auto;
}
.panel-info>.panel-heading{
  height: 50px;
}
.responstable {
  margin: 1em 0;
  width: 100%;
  overflow: hidden;
  background: #FFF;
  color: #024457;
  border-radius: 10px;
  border: 1px solid #167F92;
}
.responstable tr {
  border: 1px solid #D9E4E6;
}
.responstable tr:nth-child(odd) {
  background-color: #EAF3F3;
}
.responstable th {
  display: none;
  border: 1px solid #FFF;
  background-color: #167F92;
  color: #FFF;
  padding: 1em;
}
.responstable th:first-child {
  display: table-cell;
  text-align: center;
}
.responstable th:nth-child(2) {
  display: table-cell;
}
.responstable th:nth-child(2) span {
  display: none;
}
.responstable th:nth-child(2):after {
  content: attr(data-th);
}
@media (min-width: 480px) {
  .responstable th:nth-child(2) span {
    display: block;
  }
  .responstable th:nth-child(2):after {
    display: none;
  }
}
.responstable td {
  display: block;
  word-wrap: break-word;
  max-width: 7em;
}
.responstable td:first-child {
  display: table-cell;
  text-align: center;
  border-right: 1px solid #D9E4E6;
}
@media (min-width: 480px) {
  .responstable td {
    border: 1px solid #D9E4E6;
  }
}
.responstable th, .responstable td {
  text-align: left;
  margin: .5em 1em;
}
@media (min-width: 480px) {
  .responstable th, .responstable td {
    display: table-cell;
    padding: 1em;
  }
}
.btn-circle.btn-lg {
  width: 40px;
  height: 40px;
  padding: 1px 12px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 25px;
}
@media (max-width: 640px) {
  .placeholders {
    flex-direction: column; /* affichage vertical */
  }
}
.placeholders{
  display: flex;
  justify-content: space-between;
}

/*Fun begins TABS CSS*/

  .tab_container {
    width: 90%;
    margin: 0 auto;
    padding-top: 10px;
    position: relative;
  }

  input,
  section {
    clear: both;
    padding-top: 10px;
    display: none;
  }

  .tab_container label {
    font-weight: 700;
    font-size: 18px;
    display: block;
    float: left;
    width: 33.33%;
    padding: 1em;
    color: #757575;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    /*background: #f0f0f0;*/
    background: #E0FFFF;
  }

  .tab_container span{
    color: #3b7795;
    font-weight: normal;
  }

  @media (min-width: 480px) {
  ::-webkit-scrollbar-thumb {
    background-color: #26a0da;
  }
}

  #tab1:checked~#content1,
  #tab2:checked~#content2,
  #tab3:checked~#content3,
  #tab4:checked~#content4,
  #tab5:checked~#content5 {
    display: block;
    padding: 0px;
    background: #fff;
    color: #999;
    /*border-bottom: 2px solid #f0f0f0;*/
  }

  .tab_container .tab-content p,
  .tab_container .tab-content h3 {
    -webkit-animation: fadeInScale 0.7s ease-in-out;
    -moz-animation: fadeInScale 0.7s ease-in-out;
    animation: fadeInScale 0.7s ease-in-out;
  }

  .tab_container .tab-content h3 {
    text-align: center;
  }

  .tab_container [id^="tab"]:checked+label {
    background: #fff;
    box-shadow: inset 0 3px #0CE;
  }

  .tab_container [id^="tab"]:checked+label .fa {
    color: #0CE;
  }

  label .fa {
    font-size: 1.3em;
    margin: 0 0.4em 0 0;
  }
  /*Media query*/

  @media only screen and (max-width: 900px) {
    label span {
      display: none;
    }

    .tab_container {
     width: 98%;
    }
  }
  /* tab */
</style>



// WEBPACK FOOTER //
// src/components/Account/Transactions.vue